/* eslint-disable @typescript-eslint/no-explicit-any */
import NotificationSound from "@customHooks/notification-sound/notification-sound"
import useCallSocket from "@customHooks/voice-call/use-call-socket"
import { BasicCall, CallRecive, useVoiceCall } from "@customHooks/voice-call/use-voice-call"
import { SocketContext } from "@modules/practitioner/practitioner-module"
import { setCallInProcess, setVoiceAlert } from "@redux/slices/voice-call/voice-alert.slice"
import { setCurrentAudioTrack, setCurrentCall } from "@redux/slices/voice-call/voice-call.slice"
import { RootState } from "@redux/store"
import { IMicrophoneAudioTrack } from "agora-rtc-sdk-ng"
import { useCallback, useContext, useEffect, useState } from "react"
import addNotification from "react-push-notification"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import CallAlert from "./CallAlert"
// import SendCall from "./SendCall"

export default function VoiceNotificationContainer() {
    const session = useSelector((state: RootState) => state.session);
    const { joinCall, leaveCall } = useVoiceCall()
    const { emitSocketEvent } = useCallSocket()
    const [callInProsess, setCallInProsess] = useState<boolean>(false)
    const { socket } = useContext(SocketContext)
    const [call, setCall] = useState<CallRecive>();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [leaveUser, setLeaveUser] = useState<BasicCall>()
    const [audioTrack, setAudioTrack] = useState<IMicrophoneAudioTrack>();
    const currentCall = useSelector((state: RootState) => state.voiceCall)
    const { toggle } = NotificationSound()
    const history = useNavigate();
    const dispatch = useDispatch()

    const join = useCallback(async (data: CallRecive) => {
        // toggle('incomingCall', false);
        const audioTrack = await joinCall(`${data.room}`, data.token)
        setAudioTrack(audioTrack)
        emitSocketEvent('answer_call', {
            id: data.id,
            idEmit: data.idEmit,
            room: data.room,
        })

        dispatch(setCurrentCall({
            nameEmit: String(session.username),
            name: String(call?.name),
            id: String(call?.id),
            token: String(call?.token),
            room: `${call?.room}`,
        }))
        dispatch(setCurrentAudioTrack(audioTrack))
        dispatch(setCallInProcess({callinprocess: true}))
        setCallInProsess(true);
        setOpenModal(false)
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [call?.id, call?.name, call?.room, call?.token, dispatch, emitSocketEvent, joinCall, session.username]);

    const leave = useCallback(async (data: CallRecive, audioTrack?: IMicrophoneAudioTrack) => {
        // console.log("Leaving call from another")
        // toggle('incomingCall', false);
        leaveCall(audioTrack)
        const listener = {
            username: null,
            newCall: false
        }
        dispatch(
            setVoiceAlert(listener)
        );
        if(data){
            emitSocketEvent("leave_call", {
                name: data.nameEmit,
                id: data.id,
                token: data.token,
                room: data.room,
                idEmit: data.idEmit,
            });
            
            setCallInProsess(false);
            setCall(undefined)
            dispatch(setCurrentCall(undefined))
            setLeaveUser(undefined)
            setAudioTrack(undefined)
            setOpenModal(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, emitSocketEvent, leaveCall]);

    const cancelCall = useCallback((data: CallRecive, localAudioTrack?: IMicrophoneAudioTrack) => {
        // toggle('incomingCall', false);
        emitSocketEvent("cancel_call", {
            name: data.name,
            id: data.id,
            token: data.token,
            room: data.room,
            nameEmit: data.nameEmit,
        });
        // console.log("LEAVING!")
        leave(data, localAudioTrack);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emitSocketEvent, leave]);

    const decline = (data: CallRecive, localAudioTrack?: IMicrophoneAudioTrack) => {
        if(leaveUser) {
            leave(data, localAudioTrack)
        } else {
            cancelCall(data, localAudioTrack)
        }
    }

    const goChat = () =>{
        history('/practitioner/chat');
    }

    useEffect(() => {
        console.log("SOCKET::", socket);
        if(socket) {
            socket.on("recive_call", (data: CallRecive) => {
                // console.log("someone is calling you :: ",data)
                addNotification({
                    title: 'Tienes una llamada',
                    subtitle: 'SaludProx',
                    message: 'Alguien te esta llamando',
                    theme: 'light',
                    duration: 10000,
                    onClick: goChat,
                    closeButton: "Cerrar",
                    native: true // when using native, your OS will handle theming.
                });
                toggle('incomingCall', true);
                setCall(data)
                setOpenModal(true);
                const listener = {
                    username: data.nameEmit,
                    newCall: true
                }
                dispatch(
                    setVoiceAlert(listener)
                );
                dispatch(setCurrentCall({
                    nameEmit: String(data.nameEmit),
                    name: String(data.name),
                    id: String(data.id),
                    token: String(data.token),
                    room: `${data.room}`,
                }));
            });
            socket.on("leave", (data: BasicCall) => {
            // console.log({event: 'leave', data})
            if(currentCall){
                leave(currentCall.call as CallRecive, currentCall.audioTrack)
            }
                // setLeaveUser(data)
            });
            socket.on("users_in_call", (data: string[]) => {
                toggle('incomingCall', false);
                // console.log(data, call?.id, currentCall?.id);
                if (data) {
                    setCallInProsess(true);
                    dispatch(setCallInProcess({callinprocess: true}))
                } else {
                    setCallInProsess(false);
                    dispatch(setCallInProcess({callinprocess: false}))
                }
            });
        }

        return () => {
            if(socket) {
                socket.removeAllListeners("recive_call");
                socket.removeAllListeners("leave");
                socket.removeAllListeners("users_in_call");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioTrack, call, callInProsess, currentCall, dispatch, join, leave, socket]);

    return (
        <>
        <CallAlert
            open={openModal}
            declineCall={() => leave(call as CallRecive, audioTrack)}
            callInProsess={false}
            call={call}
            reciveCall={() => join(call as CallRecive)}
            leaveUser={undefined}
        />
        {/* <SendCall
            open={currentCall !== undefined}
            declineCall={() => decline(currentCall as CallRecive, audioTrack)}
            callInProsess={callInProsess}
            call={currentCall}
            leaveUser={leaveUser}
        /> */}
        </>
    )
}
